module.exports = __webpack_public_path__ + "static/media/MaterialIcons.945837e0.woff2";